module.exports = __webpack_public_path__ + "img/map-A-part-1.072d7e25.svg";